"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilDifferentialPair = void 0;
const z = __importStar(require("zod"));
const merge_values_js_1 = require("../utils/merge-values.js");
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const hilDifferentialPairSchema = z.object({
    id: z.string(),
    name: z.string(),
    positiveSignalId: z.union([z.string(), z.number()]).nullable(),
    negativeSignalId: z.union([z.string(), z.number()]).nullable(),
});
const hilDifferentialPairDtoSchema = z.object({
    name: z.string().optional(),
    positiveSignalId: z.union([z.string(), z.number()]).nullable().optional(),
    negativeSignalId: z.union([z.string(), z.number()]).nullable().optional(),
});
exports.HilDifferentialPair = {
    create: (input) => {
        return hilDifferentialPairSchema.parse({
            ...input,
            id: input.id ?? (0, cadstrom_shared_1.generateReadableId)(cadstrom_shared_1.CadstromObjectType.DifferentialPair, input.name ?? ''),
        });
    },
    merge: (existing, incoming) => ({
        id: existing.id,
        name: (0, merge_values_js_1.mergeValues)(existing.name, incoming.name),
        positiveSignalId: (0, merge_values_js_1.mergeValues)(existing.positiveSignalId, incoming.positiveSignalId),
        negativeSignalId: (0, merge_values_js_1.mergeValues)(existing.negativeSignalId, incoming.negativeSignalId),
    }),
    schema: hilDifferentialPairSchema,
    dtoSchema: hilDifferentialPairDtoSchema,
};
//# sourceMappingURL=hil-differential-pair.js.map